import { checkingPreload, unCheckingPreload } from '../loading';
import { setEmployeeAbsencesListRedux, setEmployeeAbsencesEmployeesSelectRedux } from './employeeAbsencesSlice';
import { 
    getEmployeeAbsencesService, 
    saveEmployeeAbsenceService, 
    updateEmployeeAbsenceService, 
    deleteEmployeeAbsenceService, 
    restoreEmployeeAbsenceService 
} from '../../services/employeeAbsences.service';

export const getEmployeeAbsencesStore = (page: number, take: number, param?: string, status: number = 1): any => {
    return async (dispatch: any) => {
        await dispatch(checkingPreload());
        const result = await getEmployeeAbsencesService(page, take, param, status);
        
        if (result && result.ok) {
            await dispatch(setEmployeeAbsencesListRedux(result.data));
            await dispatch(setEmployeeAbsencesEmployeesSelectRedux(result.data.employees));
        }
        dispatch(unCheckingPreload());
        return result;
    }
}

export const saveEmployeeAbsenceStore = (data: any, page: number, take: number, param?: string, status: number = 1): any => {
    return async (dispatch: any) => {
        await dispatch(checkingPreload());
        const result = await saveEmployeeAbsenceService(data, page, take, param, status);
        
        if (result && result.ok) {
            await dispatch(setEmployeeAbsencesListRedux(result.data));
            if (result.employees) {
                await dispatch(setEmployeeAbsencesEmployeesSelectRedux(result.employees));
            }
        }
        dispatch(unCheckingPreload());
        return result;
    }
}

export const updateEmployeeAbsenceStore = (id: string, data: any, page: number, take: number, param?: string, status: number = 1): any => {
    return async (dispatch: any) => {
        await dispatch(checkingPreload());
        const result = await updateEmployeeAbsenceService(id, data, page, take, param, status);
        
        if (result && result.ok) {
            await dispatch(setEmployeeAbsencesListRedux(result.data));
        }
        dispatch(unCheckingPreload());
        return result;
    }
}

export const deleteEmployeeAbsenceStore = (id: string, value: string, page: number, take: number, param?: string, status: number = 1): any => {
    return async (dispatch: any) => {
        await dispatch(checkingPreload());
        const result = await deleteEmployeeAbsenceService(id, value, page, take, param, status);
        
        if (result && result.ok) {
            await dispatch(setEmployeeAbsencesListRedux(result.data));
        }
        dispatch(unCheckingPreload());
        return result;
    }
}

export const restoreEmployeeAbsenceStore = (id: string, value: string, page: number, take: number, param?: string, status: number = 0): any => {
    return async (dispatch: any) => {
        await dispatch(checkingPreload());
        const result = await restoreEmployeeAbsenceService(id, value, page, take, param, status);
        
        if (result && result.ok) {
            await dispatch(setEmployeeAbsencesListRedux(result.data));
        }
        dispatch(unCheckingPreload());
        return result;
    }
}
